// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Form_formWrapper__pCDsy","formInput":"Form_formInput__xSqRa","formSubmit":"Form_formSubmit__bsAPd"};